import { RESET_TRUCK_CART, GET_TRUCK_CART } from './actionTypes';

import cartRemote from '../../api/cartRemote';

import TruckCart from '../../models/TruckCart';
import ApiResponse from '../../models/ApiResponse';
import ResponseError from '../../models/ResponseError';

import { receiveError } from './notificationAction';

function restSuccess() {
  return {
    type: RESET_TRUCK_CART
  };
}

function cartSuccess(cart: TruckCart) {
  return {
    type: GET_TRUCK_CART,
    data: cart
  };
};

function resetCart() {

  return (dispatch: Function) => {

    dispatch(restSuccess());
  };
}

function receiveCart() {

  return (dispatch: Function) => {

    cartRemote.getTruckCart().then((resp: ApiResponse<TruckCart>) => {

      handleCartResponse(resp, dispatch);
    });
  };
};

function addExportAirwayBillToCart(code: string, number: string, ver: number) {

  return (dispatch: Function) => {

    cartRemote.addExportAirwayBillToCart(code, number, ver).then((resp: ApiResponse<TruckCart>) => {

      handleCartResponse(resp, dispatch);
    });
  };
};

function addExportAirwayBillPartToCart(code: string, number: string, partId: string) {

  return (dispatch: Function) => {

    cartRemote.addExportAirwayBillPartToCart(code, number, partId).then((resp: ApiResponse<TruckCart>) => {

      handleCartResponse(resp, dispatch);
    });
  };
};

function updateWholeTruckCart(cart: TruckCart) {

  return (dispatch: Function) => {

    dispatch(cartSuccess(cart));
  };
};

function deleteExportAwbFromCart(code: string, number: string) {

  return (dispatch: Function) => {
    
    cartRemote.deleteExportAwbFromCart(code, number).then((resp: ApiResponse<TruckCart>) => {
      
      handleCartResponse(resp, dispatch);
    });
  };
};

export {
  resetCart,
  receiveCart,
  updateWholeTruckCart,
  deleteExportAwbFromCart,
  addExportAirwayBillToCart,
  addExportAirwayBillPartToCart
};

function handleCartResponse(resp: ApiResponse<TruckCart>, dispatch: Function): void {

  const cart: TruckCart | undefined = resp.result;
  const error: ResponseError | undefined = resp.error;

  if (cart) {
    dispatch(cartSuccess(cart));
  };

  if (error) {
    dispatch(receiveError(error));
  };
};